import { Col, Container, Row } from "react-bootstrap";
import BuildingAmenityForm from "../../../Components/Forms/BuildingAmenityForm/BuildingAmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditBuildingAmenityMutation, useGetBuildingAmenityByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";
import useBuildingSelectValues from "../../../Hooks/UseBuildings/useBuildingSelectValuesHook";
import useAmenitySelectValues from "../../../Hooks/UseAmenities/useAmenitySelectValuesHook";

export default function EditBuildingAmenityPage() {

    const { buildingAmenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetBuildingAmenityByIdQuery(buildingAmenityId, { skip: !buildingAmenityId })
    const buildingAmenityData = data || {}

    const [
        editBuildingAmenity,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditBuildingAmenityMutation()

    const buildingOptions = useBuildingSelectValues()
    const amenityOptions = useAmenitySelectValues()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedBuildingAmenity = await editBuildingAmenity({
            buildingAmenityId: buildingAmenityId,
            buildingAmenityInfo: values
        }).unwrap()
        if (updatedBuildingAmenity._id) {
            dispatch(navigateTo(`/building-amenity/${updatedBuildingAmenity._id}`))
        }
        return updatedBuildingAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Building Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {buildingAmenityId && buildingAmenityData && !isLoading && (
                        <BuildingAmenityForm
                            initialValues={{
                                ...buildingAmenityData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                            buildingOptions={buildingOptions}
                            amenityOptions={amenityOptions}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
